// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
/* eslint-disable import/no-named-as-default, import/no-named-as-default-member */
import calendar from './partials/way-experiences/calendar';
/* eslint-enable import/no-named-as-default, import/no-named-as-default-member */

window.moment = moment;

const filterSelects = document.querySelectorAll('.experience-select');
const typesSelect = document.querySelector('.experience-select--types');
const typesSelectLabel = typesSelect ? typesSelect.querySelector('.experience-select__label') : null;
const typesSelectDropdown = typesSelect ? typesSelect.querySelector('.experience-select__dropdown') : null;
const selectedTypes = new Set();
const seasonSelect = document.querySelector('.experience-select:not(.experience-select--types):not(.experience-select--date)');
let firstLoad = true;
let selectedSeason = null;
let selectedDates = null;
const dateSelect = document.querySelector('.experience-select--date');
const typeButtons = document.querySelectorAll('.experience-filter');
const typeCheckboxes = typesSelect ? typesSelect.querySelectorAll('.experience-types__checkbox') : [];
let dateSelectLabel = null;
const FILTER_QUERY_KEYS = {
  categories: 'categories',
  vibe: 'vibe',
  dateStart: 'date_start',
  dateEnd: 'date_end',
};

// eslint-disable-next-line new-cap
const datepicker = new calendar();

function updateSelectLine() {
  if (selectedSeason) {
    seasonSelect.classList.remove('disabled');
    if (dateSelect) dateSelect.classList.add('disabled');
  } else if (firstLoad && selectedDates) {
    dateSelect.classList.remove('disabled');
    seasonSelect.classList.add('disabled');
    firstLoad = false;
  } else if (datepicker.getDates().length > 0) {
    dateSelect.classList.remove('disabled');
    seasonSelect.classList.add('disabled');
  } else {
    dateSelect.classList.remove('disabled');
    seasonSelect.classList.remove('disabled');
  }
}

datepicker.onSelect(() => {
  updateSelectLine();
});

function updateTypesLabel() {
  if (!typesSelectLabel) return;
  if (typesSelectDropdown && typesSelectDropdown.classList.contains('active')) return;
  const span = typesSelectLabel.querySelector('span');
  const { placeholder } = span.dataset;
  if (!span) return;
  if (selectedTypes.size === 0) {
    span.textContent = placeholder;
    typesSelectLabel.classList.remove('active');
    return;
  }
  const values = Array.from(selectedTypes);
  if (values.length <= 2) {
    span.textContent = values.join(', ');
  } else {
    span.textContent = `${values.slice(0, 2).join(', ')}, +${values.length - 2}`;
  }
  typesSelectLabel.classList.add('active');
}

function removeOptionsActiveClass(options) {
  options.forEach((option) => {
    option.classList.remove('active');
  });
}

function hideAllDropdowns() {
  filterSelects.forEach((select) => {
    if (select.classList.contains('experience-select--date')) {
      return;
    }

    const dropdown = select.querySelector('.experience-select__dropdown');
    const label = select.querySelector('.experience-select__label');
    if (dropdown) {
      dropdown.classList.remove('active');
    }
    if (label) {
      label.classList.remove('open');
      if (select.classList.contains('experience-select--season')) {
        if (!selectedSeason) {
          label.classList.remove('active');
        }
      }
      // For types, active state is recalculated by updateTypesLabel()
    }
  });

  updateTypesLabel();
}

function getCheckboxType(el) {
  if (!el) return '';
  const byId = el.getAttribute('id');
  if (byId && byId.trim()) return byId.trim();
  const byData = el.getAttribute('data-type');
  return byData ? byData.trim() : '';
}

function deactivateUnselectedTypes() {
  typeButtons.forEach((button) => {
    if (!selectedTypes.has(button.getAttribute('data-type'))) {
      button.classList.remove('is-active');
    }
  });

  typeCheckboxes.forEach((checkbox) => {
    if (!selectedTypes.has(getCheckboxType(checkbox))) {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = false;
    }
  });
}

function applySelectedTypesToUI() {
  typeButtons.forEach((btn) => {
    const type = btn.getAttribute('data-type');
    if (!type) return;
    if (selectedTypes.has(type)) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  });

  if (typesSelect && typeCheckboxes && typeCheckboxes.length) {
    Array.from(typeCheckboxes).forEach((checkbox) => {
      const type = getCheckboxType(checkbox);
      if (!type) return;
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = selectedTypes.has(type);
    });
  }
}

function applySelectedSeasonToUI() {
  if (!seasonSelect) return;
  const label = seasonSelect.querySelector('.experience-select__label');
  const span = label ? label.querySelector('span') : null;
  const options = seasonSelect.querySelectorAll('.experience-select__dropdown-option');

  if (options && options.length) {
    removeOptionsActiveClass(options);
  }

  if (selectedSeason) {
    let matchedOption = null;
    if (options && options.length) {
      matchedOption = Array.from(options).find((option) => option.getAttribute('data-season') === selectedSeason);
    }
    if (matchedOption) {
      matchedOption.classList.add('active');
      if (span) {
        span.textContent = matchedOption.textContent;
      }
      if (label) {
        label.classList.add('active');
      }
    }
  }
}

function applySelectedDatesToUI() {
  if (!dateSelectLabel) {
    dateSelectLabel = document.querySelector('.experience-select--date .experience-select__label');
  }
  if (!dateSelectLabel) return;

  const span = dateSelectLabel.querySelector('span');
  if (!span) return;

  if (selectedDates && selectedDates.length === 2) {
    datepicker.setDates(selectedDates, true);
  }
}

function syncUrlFromFilters() {
  if (typeof window === 'undefined' || typeof window.history === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  const {
    categories,
    vibe,
    dateStart,
    dateEnd,
  } = FILTER_QUERY_KEYS;

  url.searchParams.delete(categories);
  url.searchParams.delete(`${categories}`);
  url.searchParams.delete(vibe);
  url.searchParams.delete(dateStart);
  url.searchParams.delete(dateEnd);

  if (selectedTypes.size > 0) {
    const categoriesArray = Array.from(selectedTypes)
      .filter((type) => type && typeof type === 'string')
      .map((type) => type.trim())
      .filter((type) => type);
    if (categoriesArray.length > 0) {
      categoriesArray.forEach((category) => {
        url.searchParams.append(`${categories}`, category);
      });
    }
  }

  const normalizedSeason = typeof selectedSeason === 'string' ? selectedSeason.trim() : '';
  if (normalizedSeason) {
    url.searchParams.set(vibe, normalizedSeason);
    url.searchParams.delete(dateStart);
    url.searchParams.delete(dateEnd);
  }

  const pickerDates = datepicker.getDatesFormatted();
  if (!normalizedSeason && pickerDates && pickerDates.length === 2) {
    url.searchParams.set(dateStart, pickerDates[0]);
    url.searchParams.set(dateEnd, pickerDates[1]);
  }

  const newUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, '', newUrl);
}

function syncFiltersFromUrl() {
  if (typeof window === 'undefined') {
    return false;
  }

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const {
    categories,
    vibe,
    dateStart,
    dateEnd,
  } = FILTER_QUERY_KEYS;
  let filtersApplied = false;

  const categoriesArray = params.getAll(`${categories}`);
  const categoriesValue = params.get(categories);
  const normalizedCategories = [];

  if (categoriesArray.length > 0) {
    categoriesArray.forEach((value) => {
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed) {
          normalizedCategories.push(trimmed);
        }
      }
    });
  } else if (categoriesValue && typeof categoriesValue === 'string') {
    categoriesValue.split(',').forEach((part) => {
      const trimmed = part.trim();
      if (trimmed) {
        normalizedCategories.push(trimmed);
      }
    });
  }

  if (normalizedCategories.length > 0) {
    selectedTypes.clear();
    normalizedCategories.forEach((type) => selectedTypes.add(type));
    applySelectedTypesToUI();
    updateTypesLabel();
    filtersApplied = true;
  }

  if (params.has(vibe)) {
    const vibeValue = params.get(vibe);
    const normalizedVibe = typeof vibeValue === 'string' ? vibeValue.trim() : '';
    selectedSeason = normalizedVibe || null;
    applySelectedSeasonToUI();
    if (normalizedVibe) {
      filtersApplied = true;
      if (selectedDates !== null) {
        selectedDates = null;
        applySelectedDatesToUI(true);
      }
      if (params.has(dateStart) || params.has(dateEnd)) {
        url.searchParams.delete(dateStart);
        url.searchParams.delete(dateEnd);
        const newUrl = `${url.pathname}${url.search}${url.hash}`;
        if (typeof window !== 'undefined' && typeof window.history !== 'undefined') {
          window.history.replaceState({}, '', newUrl);
        }
      }
    }
  }

  const hasDateParams = params.has(dateStart) || params.has(dateEnd);
  if (!selectedSeason && hasDateParams) {
    const startRaw = params.get(dateStart);
    const endRaw = params.get(dateEnd);
    const startValue = typeof startRaw === 'string' ? startRaw.trim() : '';
    const endValue = typeof endRaw === 'string' ? endRaw.trim() : '';
    if (startValue && endValue) {
      selectedDates = [startValue, endValue];
      filtersApplied = true;
    } else {
      selectedDates = null;
    }
    applySelectedDatesToUI();
  }

  if (filtersApplied) {
    updateSelectLine();
  }

  return filtersApplied;
}

// Close all filters except the provided one (also hides date picker if open)
function closeOtherFilters(currentSelect) {
  filterSelects.forEach((select) => {
    if (select === currentSelect) {
      return;
    }

    const dropdown = select.querySelector('.experience-select__dropdown');
    const label = select.querySelector('.experience-select__label');
    if (dropdown) {
      dropdown.classList.remove('active');
    }
    if (label) {
      label.classList.remove('open');
    }
  });

  updateTypesLabel();
}

document.addEventListener('click', (e) => {
  const { target } = e;
  if (!target.closest('.experience-select')) {
    hideAllDropdowns();
  }
});

const experienceGrid = document.querySelector('.experience-grid');
const experienceResults = document.querySelector('.experience-results');
const clearFiltersBtn = experienceResults ? experienceResults.querySelector('.experience-results__clear') : null;
const loadMoreBtn = document.querySelector('.experience-load-more');
let currentPage = 1;
let isLoading = false;
let debounceTimer = null;
let pendingRequest = false;

typeButtons.forEach((btn) => {
  if (btn.classList.contains('is-active')) {
    const type = btn.getAttribute('data-type');
    if (type) {
      selectedTypes.add(type);
    }
  }
});

syncFiltersFromUrl();

function applyExperienceFilters(isLoadMore = false) {
  if (!window.jQuery || !window.way_experience) {
    return;
  }

  if (!isLoadMore) {
    syncUrlFromFilters();
  }

  if (isLoading) return;

  if (!isLoadMore) {
    currentPage = 1;
  }

  const requestData = {
    page: currentPage,
  };

  if (selectedTypes.size > 0) {
    requestData.categories = Array.from(selectedTypes);
  }

  if (selectedSeason) {
    requestData.vibe = selectedSeason;
  }

  if (datepicker?.getDates()?.length === 2) {
    requestData.date = datepicker?.getDatesFormatted();
  }

  isLoading = true;
  if (experienceGrid) {
    experienceGrid.style.opacity = '0.5';
  }

  window.jQuery.ajax({
    url: window.ajaxurl || '/wp-admin/admin-ajax.php',
    type: 'POST',
    data: {
      action: 'get_way_experiences',
      nonce: window.way_experience?.nonce,
      args: requestData,
    },
    success(response) {
      isLoading = false;
      if (experienceGrid) {
        experienceGrid.style.opacity = '1';
      }

      if (response.success && response.data) {
        const { items, has_more: hasMore } = response.data;

        if (items && typeof items === 'string' && items.trim().length > 0) {
          // eslint-disable-next-line no-use-before-define
          renderExperiences(items, isLoadMore);

          if (experienceResults) {
            experienceResults.classList.remove('active');
          }

          // eslint-disable-next-line no-use-before-define
          toggleLoadMoreButton(hasMore);
        } else if (!isLoadMore) {
          if (experienceGrid) {
            experienceGrid.innerHTML = '';
          }
          if (experienceResults) {
            experienceResults.classList.add('active');
          }
          // eslint-disable-next-line no-use-before-define
          toggleLoadMoreButton(false);
        }
      } else if (!isLoadMore) {
        if (experienceGrid) {
          experienceGrid.innerHTML = '';
        }
        if (experienceResults) {
          experienceResults.classList.add('active');
        }
        // eslint-disable-next-line no-use-before-define
        toggleLoadMoreButton(false);
      }

      if (pendingRequest) {
        pendingRequest = false;
        applyExperienceFilters(false);
      }
    },
    error() {
      isLoading = false;
      if (experienceGrid) {
        experienceGrid.style.opacity = '1';
      }
      if (!isLoadMore) {
        if (experienceResults) {
          experienceResults.classList.add('active');
        }
        // eslint-disable-next-line no-use-before-define
        toggleLoadMoreButton(false);
      }

      if (pendingRequest) {
        pendingRequest = false;
        applyExperienceFilters(false);
      }
    },
  });
}

function applyExperienceFiltersDebounced(isLoadMore = false, delay = 250) {
  if (isLoadMore) {
    applyExperienceFilters(true);
    return;
  }

  syncUrlFromFilters();

  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(() => {
    if (isLoading) {
      pendingRequest = true;
    } else {
      applyExperienceFilters(false);
    }
  }, delay);
}

function renderExperiences(htmlString, append = false) {
  if (!experienceGrid) return;

  if (!append) {
    experienceGrid.innerHTML = '';
  }

  if (append) {
    experienceGrid.insertAdjacentHTML('beforeend', htmlString);
  } else {
    experienceGrid.innerHTML = htmlString;
  }
}

function toggleLoadMoreButton(show) {
  const loadMoreContainer = document.querySelector('.experience-actions');
  if (!loadMoreContainer) return;

  if (show) {
    loadMoreContainer.style.removeProperty('display');
  } else {
    loadMoreContainer.style.display = 'none';
  }
}

typeButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const type = btn.getAttribute('data-type');
    if (!type) {
      return;
    }

    btn.classList.toggle('is-active');

    if (btn.classList.contains('is-active')) {
      selectedTypes.clear();
      selectedTypes.add(type);
    } else {
      selectedTypes.clear();
    }

    deactivateUnselectedTypes();

    if (typesSelect && typeCheckboxes && typeCheckboxes.length) {
      const cb = Array.from(typeCheckboxes).find((c) => getCheckboxType(c) === type);
      if (cb) {
        cb.checked = btn.classList.contains('is-active');
      }
    }

    updateTypesLabel();
    applyExperienceFiltersDebounced();
  });
});

filterSelects.forEach((select) => {
  if (select.classList.contains('experience-select--types') || select.classList.contains('experience-select--date')) {
    return;
  }
  const dropdown = select.querySelector('.experience-select__dropdown');
  const options = dropdown ? dropdown.querySelectorAll('.experience-select__dropdown-option') : [];
  const label = select.querySelector('.experience-select__label');

  if (label) {
    label.addEventListener('click', (e) => {
      e.stopPropagation();
      label.classList.remove('active');
      closeOtherFilters(select);
      if (dropdown) {
        dropdown.classList.toggle('active');
      }
      label.classList.toggle('open');
    });
  }

  options.forEach((option) => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();
      const { target } = e;
      const season = target.getAttribute('data-season');
      if ((season && season === selectedSeason) || option.classList.contains('active')) {
        removeOptionsActiveClass(options);
        if (label && label.querySelector('span')) label.querySelector('span').textContent = 'Select Season';
        if (dropdown) dropdown.classList.remove('active');
        if (label) {
          label.classList.remove('open');
          label.classList.remove('active');
        }
        selectedSeason = null;
        updateSelectLine();
        applyExperienceFiltersDebounced();
        return;
      }

      removeOptionsActiveClass(options);
      if (label && label.querySelector('span')) label.querySelector('span').textContent = target.textContent;
      if (dropdown) dropdown.classList.remove('active');
      option.classList.add('active');
      if (label) {
        label.classList.remove('open');
        label.classList.add('active');
      }

      selectedSeason = season || null;
      updateSelectLine();
      applyExperienceFiltersDebounced();
    });
  });
});

if (typesSelect && typesSelectLabel && typesSelectDropdown) {
  typesSelectLabel.addEventListener('click', (e) => {
    e.stopPropagation();
    typesSelectLabel.classList.remove('active');
    closeOtherFilters(typesSelect);
    typesSelectDropdown.classList.toggle('active');
    typesSelectLabel.classList.toggle('open');

    const span = typesSelectLabel.querySelector('span');
    const { placeholder } = span.dataset;
    if (typesSelectDropdown.classList.contains('active')) {
      if (span) span.textContent = placeholder;
    } else {
      updateTypesLabel();
    }
  });

  typesSelectDropdown.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  for (let i = 0; i < typeCheckboxes.length; i++) {
    const checkbox = typeCheckboxes[i];
    checkbox.addEventListener('change', (e) => {
      const { checked } = e.target;
      const type = getCheckboxType(e.target);
      if (!type) {
        return;
      }

      if (checked) {
        selectedTypes.clear();
        selectedTypes.add(type);
      } else {
        selectedTypes.clear();
      }

      deactivateUnselectedTypes();

      updateTypesLabel();
      applyExperienceFiltersDebounced();
    });
  }
}

document.addEventListener('change', (e) => {
  const { target } = e;
  if (!target || !target.classList || !target.classList.contains('experience-types__checkbox')) {
    return;
  }
  const type = getCheckboxType(target);
  if (!type) {
    return;
  }
  if (target.checked) {
    selectedTypes.add(type);
  } else {
    selectedTypes.delete(type);
  }
  document.querySelectorAll(`.experience-filter[data-type="${type}"]`).forEach((btn) => {
    if (target.checked) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  });
  updateTypesLabel();
  applyExperienceFiltersDebounced();
});

setTimeout(() => {
  datepicker.onRefresh(() => {
    applyExperienceFiltersDebounced();
  });
}, 2000);

if (clearFiltersBtn) {
  clearFiltersBtn.addEventListener('click', () => {
    currentPage = 1;
    selectedTypes.clear();
    selectedSeason = null;
    selectedDates = null;

    typeButtons.forEach((btn) => {
      btn.classList.remove('is-active');
    });

    const seasonOptions = document.querySelectorAll('.experience-select__dropdown-option');
    removeOptionsActiveClass(seasonOptions);
    const seasonLabels = document.querySelectorAll('.experience-select__label');
    Array.from(seasonLabels).forEach((label) => {
      const span = label.querySelector('span');
      if (span) {
        span.textContent = 'Select Season';
      }
      label.classList.remove('active');
      label.classList.remove('open');
    });
    const seasonDropdown = document.querySelector('.experience-select__dropdown');
    if (seasonDropdown) {
      seasonDropdown.classList.remove('active');
    }

    if (typeCheckboxes && typeCheckboxes.length) {
      // eslint-disable-next-line no-param-reassign
      typeCheckboxes.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = false;
      });
    }
    if (typesSelectLabel) {
      const base = 'Select Category';
      typesSelectLabel.querySelector('span').textContent = base;
      typesSelectLabel.classList.remove('active');
      typesSelectLabel.classList.remove('open');
    }
    if (typesSelectDropdown) {
      typesSelectDropdown.classList.remove('active');
    }

    datepicker.clear();

    updateSelectLine();

    applyExperienceFilters();
  });
}

if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', () => {
    currentPage += 1;

    applyExperienceFilters(true);
  });
}

updateSelectLine();
updateTypesLabel();
